import { Capacitor } from '@capacitor/core';
import { Network } from '@capacitor/network';

/**
 * Thrown when the device has no network connectivity.
 *
 * Caught by {@link mapSupabaseError} in `errorMapper.ts` to display a
 * user-friendly offline message.
 */
export class OfflineError extends Error {
  constructor() {
    super('OFFLINE');
    this.name = 'OfflineError';
  }
}

/**
 * Asserts that the device currently has network connectivity.
 *
 * Uses the Capacitor Network plugin on native platforms and
 * `navigator.onLine` on the web. Call at the top of every mutation
 * function before any Supabase call.
 *
 * @returns Resolves with no value when the device is online.
 * @throws {OfflineError} When the device has no network connection.
 */
export async function assertOnline(): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    const status = await Network.getStatus();
    if (!status.connected) throw new OfflineError();
  } else {
    if (!navigator.onLine) throw new OfflineError();
  }
}
